import React from 'react';
import { Checkbox, Tooltip } from '@marvelapp/ui';
function SelectAllCheckbox({ allItems, clearSelectedItems, kind, selectAllItems, selectedItems, size, tooltipPosition, }) {
    return (React.createElement(Tooltip, { content: allItems.length === selectedItems.length ? 'Deselect all' : 'Select all', display: "block", position: tooltipPosition },
        React.createElement(Checkbox, { "data-testid": "select-all-checkbox", display: "block", isChecked: getCheckboxState({ allItems, selectedItems }), kind: kind, onChange: allItems.length === selectedItems.length
                ? clearSelectedItems
                : selectAllItems, size: size })));
}
function getCheckboxState({ allItems, selectedItems }) {
    if (selectedItems.length === 0)
        return false;
    if (allItems.length === selectedItems.length)
        return true;
    if (allItems.length !== selectedItems.length)
        return null;
}
export default SelectAllCheckbox;
